module.exports = {"520625001":"峨岭街道","520625002":"龙津街道","520625003":"中兴街道","520625101":"板溪镇","520625102":"沙子坡镇","520625103":"天堂镇","520625104":"木黄镇","520625105":"合水镇","520625106":"朗溪镇","520625107":"缠溪镇","520625108":"洋溪镇","520625109":"新寨镇","520625110":"杉树镇","520625111":"刀坝镇","520625112":"紫薇镇","520625113":"杨柳镇","520625206":"罗场乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520625.json
// module id = 2497
// module chunks = 0